import { Input } from 'util/ui'
import asCursorManaged from './asCursorManaged'

const CursorManagedInput = asCursorManaged(Input, {
  refPropertyName: 'inputRef',
})

export default CursorManagedInput
